import React from 'react';
import moment from 'moment';
import { FiSearch, FiUsers, FiX } from 'react-icons/fi';

const CalendarToolbar = ({ filteredGroupedDays, artistSearch, onArtistSearchChange, onOpenCustomerSearch, onScrollToMonth, onScrollToTop }) => {
  const currentMonthKey = moment().format('YYYY-MM');
  return <div className="sticky-container">
    <div className="month-navbar sticky-navbar">
      {Object.keys(filteredGroupedDays).sort().filter(key => key >= currentMonthKey).map(key =>
        <a key={`nav-${key}`} className="month-link" href={`#month-${key}`} onClick={event => { event.preventDefault(); onScrollToMonth(key); }}>{filteredGroupedDays[key]?.label?.slice(0, 3)}</a>)}
      <button type="button" className="scroll-to-top" onClick={onScrollToTop} title="Nach oben">↑</button>
    </div>
    <div className="search-bar mobile-search-compact">
      <button type="button" className={`search-toggle ${artistSearch ? 'active' : ''}`} title="Künstler suchen" aria-label="Künstler suchen" onClick={() => {
        const value = window.prompt('Künstler suchen:', artistSearch); if (value !== null) onArtistSearchChange(value);
      }}><FiUsers aria-hidden="true" /></button>
      {artistSearch && (
        <button
          type="button"
          className="search-toggle artist-filter-clear"
          onClick={() => onArtistSearchChange('')}
          title="Künstlerfilter entfernen"
          aria-label="Künstlerfilter entfernen"
        >
          <FiX aria-hidden="true" />
        </button>
      )}

      <button type="button" className="search-toggle" onClick={onOpenCustomerSearch} title="Kunde suchen" aria-label="Kunde suchen"><FiSearch aria-hidden="true" /></button>
    </div>
  </div>;
};
export default CalendarToolbar;
